// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"calendar-edit"},"nodeName":"g","children":[{"attributes":{"id":"fill2","fill":"transparent","d":"M15.0008 22.5L15 19.7866L19.2866 15.5L22 18.2134L17.7134 22.5H15.0008Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M3 10V21H11M3 10H21M3 10V5H21V10M21 10V12M7 5V2M17 5V2","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M17.2006 17.586L15 19.7866L15.0008 22.5H17.7134L19.914 20.2994M17.2006 17.586L19.2866 15.5L22 18.2134L19.914 20.2994M17.2006 17.586L19.914 20.2994","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-calendar-edit')
export default class CalendarEditIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'calendar-edit',
    }
  }
}
